import About from '../modules/about/action/About'
import New from '../modules/start/action/New'
import Offline from '../modules/start/action/Offline'
import Search from '../modules/search/action/Search'
import Start from '../modules/start/action/Start'
import ReportPeople from '../modules/report/action/ReportPeople'
import Import from '../modules/import/action/Import'
import Export from '../modules/export/action/Export'
import EditPerson from '../modules/person/action/EditPerson'
import EditPosition from '../modules/position/action/EditPosition'
import EditEducation from '../modules/education/action/EditEducation'
import EditOrganisation from '../modules/organisation/action/EditOrganisation'
import EditLocation from '../modules/location/action/EditLocation'
import EditLogentry from '../modules/logentry/action/EditLogentry'
import EditRelationship from '../modules/relationship/action/EditRelationship'
import EditFile from '../modules/file/action/EditFile'
import EnterCredentials from '../modules/start/action/EnterCredentials'
import ChangeCredentials from '../modules/start/action/ChangeCredentials'
import Welcome from '../modules/start/action/Welcome'
import Sync from '../modules/start/action/Sync'

export default class NavigationManager {
  constructor (element) {
    this.element = element
    addEventListener('popstate', this.handleNavigation.bind(this))
  }

  handleNavigation () {
    window.PRIM.cancelDelayedNavigation()

    let path = location.hash.split('/')

    if (path.length < 2) {
      return
    }

    this.element.innerHTML = ''

    // split on '/'
    switch (path[1]) {
      case 'sync':
        new Sync(this.element)
        break
      case 'people':
        new EditPerson(this.element, {id: path.length > 2 ? path[2] : undefined})
        break
      case 'files':
        new EditFile(this.element, {id: path.length > 2 ? path[2] : undefined})
        break
      case 'positions':
        new EditPosition(this.element, {
          id: path.length === 3 ? path[2] : undefined,
          person_id: path.length > 3 && path[2] === 'person' ? path[3] : undefined,
          location_id: path.length > 3 && path[2] === 'location' ? path[3] : undefined
        })
        break
      case 'educations':
        new EditEducation(this.element, {
          id: path.length === 3 ? path[2] : undefined,
          location_id: path.length > 3 ? path[3] : undefined
        })
        break
      case 'organisations':
        new EditOrganisation(this.element, {id: path.length > 2 ? path[2] : undefined})
        break
      case 'locations':
        new EditLocation(this.element, {
          id: path.length === 3 ? path[2] : undefined,
          organisation_id: path.length > 3 ? path[3] : undefined
        })
        break
      case 'logentries':
        new EditLogentry(this.element, {
          id: path.length === 3 ? path[2] : undefined,
          object_type: path.length > 3 ? path[2] : undefined,
          target_id: path.length > 3 ? path[3] : undefined
        })
        break
      case 'relationships':
        new EditRelationship(this.element, {
          id: path.length === 3 ? path[2] : undefined,
          person_id: path.length > 3 ? path[3] : undefined
        })
        break
      case 'about':
        new About(this.element)
        break
      case 'reportpeople':
        new ReportPeople(this.element)
        break 
      case 'import':
        new Import(this.element)
        break  
      case 'export':
        new Export(this.element)
        break  
      case 'entercredentials':
        new EnterCredentials(this.element)
        break
      case 'changecredentials':
        new ChangeCredentials(this.element)
        break
      case 'offline':
        new Offline(this.element)
        break
      case 'start':
        new Start(this.element)
        break
      case 'new':
        new New(this.element)
        break
      case 'search':
        new Search(this.element)
        break
      default:
        new EnterCredentials(this.element)
        break
    }
  }
}




// WEBPACK FOOTER //
// ./js/lib/NavigationManager.js